import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ITicketHead, ITicketBody } from "../../interfaces";
import Axios from "axios";
import config from "../../config";
import CoreComponent from "../CoreComponent";
import { toast } from "react-toastify";
import { arrayToFormData } from "../../utils/functions";

interface IState {
    model: ITicketHead;
    models: ITicketBody[];
    isLoading: boolean;
    message: string;
}

class Ticket extends CoreComponent<any, IState> {
    private scroll: any = null;

    state: IState = {
        models: [],
        model: null,
        isLoading: true,
        message: "",
    };

    constructor(props: any) {
        super(props);
    }

    componentWillMount() {
        this.loadModels();
    }

    async loadModels() {
        let url = null;

        url = `${config.api}/ticket/body?id=${this.props.match.params.id}`;

        let res = await Axios.get(url);

        if (res.data.status == "success")
            if (!this.isUnmounted) {
                this.setState(
                    {
                        models: res.data.models,
                        model: res.data.model,
                        isLoading: false,
                    },
                    () => {
                        this.scroll.scrollTop = this.scroll.scrollHeight;
                    }
                );
            } else toast(res.data.message, { type: "error" });
    }

    async handleSubmit() {
        if (this.state.message.length > 0) {
            let res = await Axios.post(
                `${config.api}/ticket/send`,
                arrayToFormData({
                    message: this.state.message,
                    id: this.props.match.params.id,
                })
            );

            if (res.data.status == "success") {
                toast("Сообщение отправлено", {
                    type: "success",
                });

                this.setState(
                    {
                        models: [...this.state.models, res.data.model],
                        message: ""
                    },
                    () => {
                        this.scroll.scrollTop = this.scroll.scrollHeight;
                    }
                );
            } else {
                toast("Сообщение не отправлено", {
                    type: "error",
                });
            }
        }
    }

    render() {
        let { auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders quastions">
                <div className="wrapper">
                    <h1 className="riz-mobi__title title-index mb-0">Вопросы</h1>

                    <div className="riz-crm__theme">
                        <span>Тема:</span>
                        <span>{this.state.model?.topic}</span>
                    </div>
                    <div
                        className="pb-3"
                        style={{ backgroundColor: "#232636" }}
                    >
                        <div
                            className="riz-crm__chat"
                            ref={(ref) => (this.scroll = ref)}
                        >
                            {this.state.models.map(
                                (model: ITicketBody, i: number) => {
                                    return (
                                        <div
                                            className={
                                                "riz-crm__cover " +
                                                (model.client == 2
                                                    ? "jc-fe"
                                                    : "reverse")
                                            }
                                        >
                                            <div
                                                className={
                                                    "riz-crm__chat-" +
                                                    (model.client == 2
                                                        ? "right"
                                                        : "left")
                                                }
                                            >
                                                <div className="riz-chat__message">
                                                    <div className="riz-crm__chat-title">
                                                        {model.user.full_name}
                                                    </div>
                                                    <div className="riz-crm__chat-descr">
                                                        {model.text}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="riz-chat__avatar ml">
                                                {model.user.image && (
                                                    <img
                                                        src={model.user.image}
                                                        alt=""
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                        <form
                            className="riz-crm__chat-form"
                            onSubmit={(e) => {
                                e.preventDefault();

                                this.handleSubmit();
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Написать сообщение..."
                                value={this.state.message}
                                onChange={(e: any) => {
                                    this.setState({
                                        message: e.target.value,
                                    });
                                }}
                            />
                            <button type="submit">Отправить</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
    };
})(withTranslation()(Ticket));
